module.exports = __webpack_public_path__ + "static/media/shuffle.89f53ebc.wav";